export default "__VITE_PUBLIC_ASSET__d01ff25a__"